import { alpha, Stack, Typography, useTheme } from "@mui/material";
import {
	Infinity as InfinityIcon,
	TrendingDown,
	TrendingUp,
} from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	accumFlex: number;
	drawFlex: number;
	isPerpetual: boolean;
};

const BAR_HEIGHT = 40;
const RADIUS = "12px";

export const RentTimelineBar: FC<Props> = ({
	accumFlex,
	drawFlex,
	isPerpetual,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const accumColor = theme.palette.blue.main;
	const drawColor = theme.palette.orange.main;

	return (
		<Stack direction="row" alignItems="stretch" gap={0.5}>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="center"
				gap={0.75}
				px={1}
				height={BAR_HEIGHT}
				bgcolor={alpha(accumColor, 0.12)}
				flexGrow={accumFlex}
				flexBasis={0}
				borderRadius={`${RADIUS} 0 0 ${RADIUS}`}
			>
				<TrendingUp
					size={theme.iconSize.sm}
					color={accumColor}
					style={{ flexShrink: 0 }}
				/>
				<Typography variant="captionStrong" color={accumColor} noWrap>
					{t(Resources.Goals.Detail.RentPlan.phaseAccumulation)}
				</Typography>
			</Stack>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="center"
				gap={0.75}
				px={1}
				height={BAR_HEIGHT}
				flexGrow={drawFlex}
				flexBasis={0}
				sx={{
					background: isPerpetual
						? `linear-gradient(to right, ${alpha(drawColor, 0.18)}, ${alpha(drawColor, 0.04)})`
						: alpha(drawColor, 0.15),
				}}
				borderRadius={isPerpetual ? 0 : `0 ${RADIUS} ${RADIUS} 0`}
			>
				{isPerpetual ? (
					<InfinityIcon
						size={theme.iconSize.sm}
						color={drawColor}
						style={{ flexShrink: 0 }}
					/>
				) : (
					<TrendingDown
						size={theme.iconSize.sm}
						color={drawColor}
						style={{ flexShrink: 0 }}
					/>
				)}
				<Typography variant="captionStrong" color={drawColor} noWrap>
					{t(Resources.Goals.Detail.RentPlan.phaseDrawdown)}
				</Typography>
			</Stack>
		</Stack>
	);
};
